define([
    "skylark-utils/finder"
], function(finder) {
    return finder;
});
